import { render, staticRenderFns } from "./BuscarProducto.vue?vue&type=template&id=0738250b&scoped=true&"
import script from "./BuscarProducto.vue?vue&type=script&lang=js&"
export * from "./BuscarProducto.vue?vue&type=script&lang=js&"
import style0 from "./BuscarProducto.vue?vue&type=style&index=0&id=0738250b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0738250b",
  null
  
)

export default component.exports